import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fullscreen",
  "use": "icon-fullscreen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fullscreen\"><path d=\"M853.344 810.656H704V896h170.656c36.256 0 64-27.744 64-64v-170.656h-85.344v149.344zM874.656 128H704v85.344h149.344v149.344h85.344V192.032c0-36.256-27.744-64-64-64zM85.344 192v170.656h85.344V213.312h149.344V127.968H149.376c-36.256 0-64 27.744-64 64zM170.656 661.344H85.312V832c0 36.256 27.744 64 64 64h170.656v-85.344H170.624v-149.344z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol